import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "../../../Contexts/userContext";
import { useRoleAccess } from "../../../hooks/useRoleAccess";

interface AdminRouteProps {
  fallback?: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({
  fallback = <Navigate to="/" replace />,
}) => {
  const { user } = useUserContext();
  const { isAdmin } = useRoleAccess();

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!isAdmin()) {
    return <>{fallback}</>;
  }

  return <Outlet />;
};
